import { CustomWorkout } from './custom_workout';
import { StreakCompletionResult } from './user_streak';
export class UserCustomWorkout {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "customWorkoutID", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "duration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "calorie", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "date", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "customWorkout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "streakCompletionResult", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.userID = data.userID;
        this.customWorkoutID = data.customWorkoutID;
        this.duration = data.duration;
        this.calorie = data.calorie;
        this.date = data.date;
        this.customWorkout = data.customWorkout && new CustomWorkout(data.customWorkout);
        this.streakCompletionResult =
            data.streakCompletionResult && new StreakCompletionResult(data.streakCompletionResult, config);
    }
}
